import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';

import get from 'lodash/get';

import {
  loadCampaign,
  syncCampaignGeoFilter,
  syncCampaignResponseFilter,
  loadActiveUser,
  loadRetailers,
  loadPublishersForCampaign,
  updatePublishersForCampaign,
  loadCampaignReach,
  targetCampaign,
  loadEngagementsForCampaign
} from '../../shared/redux/entities/actions';

import {
  loadKPIsForCampaign
} from '../../shared/redux/kpis/actions';

import {
  loadListOfStatesAndDMAs
} from '../../shared/redux/audience/actions';
import {getActiveUser} from "../../shared/redux/selectors";
import values from "lodash/values";
import {alphabeticallySort} from "../../shared/utils";

function getRetailers(state){
  return values(state.entities.companies)
      .filter((c) => !c.isBrand && c.name && c.name.length > 0)
      .filter((r) => r.name && r.name.length > 0)
      .sort((a,b) => alphabeticallySort(a.name,b.name))
}


function mapStateToProps(state,props){
  const campaignId = props.match.params.campaignId,
      activeCampaign = get(state,['entities','campaigns',campaignId],{}),
    agencyId = get(state,['entities','campaigns',campaignId,'agencyId'],null);
  const activeUser = getActiveUser(state);

  return {
    activeCampaign:activeCampaign,
    activeUser:activeUser,
    geofilters:state.audience.geofilters,
    campaignId:campaignId,
    agencyId:agencyId,
    retailers:getRetailers(state),
    engagements:values(get(state,['entities','engagements'], {})),
    activeCampaignGeoFilterPredicate:get(state,['entities','campaigns',campaignId,'geoFilterPredicate'],null),
    activeCampaignFilters:get(state,['entities','campaigns',campaignId,'filters'],[]),
    activeCampaignConstraints:get(state,['entities','campaigns',campaignId,'constraints'],[]),
    // campaignFilters:(state.audience.responseConstraints || []).filter((r) => r.agencyId === agencyId && r.name.length > 0),
    campaignFilters:values(get(state,['entities','campaigns'], {})).filter((r) => r.agencyId === agencyId && r.name.length > 0),

    engagementFilters:[],
    campaignKpis:Object.values(state.kpis.campaigns)
  };
}

function mapDispatchToProps(dispatch){
  //TODO: Bind Redux action creators to GuidedCampaignAudience
  return bindActionCreators({
    loadListOfStatesAndDMAs,
    loadPublishersForCampaign,
    updatePublishersForCampaign,
    loadCampaignReach,
    loadRetailers,
    loadCampaign,
    loadEngagementsForCampaign,
    loadKPIsForCampaign,
    syncCampaignGeoFilter,
    syncCampaignResponseFilter,
    targetCampaign
  },dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignAudience/connect.js